<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">定期投资查询和终止</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
    </el-row>
    <div style="width:775px;margin:20px auto;">
      <div class="d-alert">定期投资终止确认</div>
      <p class="tips">您确定要进行以下定期投资终止操作吗？</p>
      <el-form :model="fixedStopForm" :rules="fixedStopFormRules" ref="fixedStopFormRef" class="table-normal-form">
        <table class="table-normal-one margin-t15" cellspacing="0">
          <tbody>
            <tr>
              <td style="width:190px">协议号</td>
              <td>{{fundMessage.buyplanno}}</td>
            </tr>
            <tr>
              <td>{{sign? '产品名称':'基金名称'}}</td>
              <td class="aColor">
                <el-form-item style="display:none;">
                  <el-input v-model="fixedStopForm.name"></el-input>
                </el-form-item>
                <span>{{sign?'恒宝宝': '['+fundMessage.fundcode+']'+fundMessage.fundname}}</span>
              </td>
            </tr>
            <tr>
              <td>业务类别</td>
              <td>{{fundMessage.saveplanflag == '1'? '定期定额':'定期不定额'}}</td>
            </tr>
            <tr>
              <td>扣款银行</td>
              <td>{{fundMessage.account}}</td>
            </tr>
            <tr>
              <td>首次扣款日期</td>
              <td>{{$commonJs.getDateStrHz(fundMessage.firstinvestdate)}}</td>
            </tr>
            <tr>
              <td>首次扣款金额</td>
              <td>{{fundMessage.firstinvestamount}}</td>
            </tr>
            <tr>
              <td>后续投资方式</td>
              <td>{{condesc}}</td>
            </tr>
            <tr>
              <td>交易密码</td>
              <td>
                <el-form-item prop="passwd" :error="pwdError">
                  <el-input type="password" autocomplete="new-password" v-model="fixedStopForm.passwd"></el-input>
                </el-form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="btnCenter">
          <el-button type="normal" @click="stopSubmit">确认</el-button>
          <el-button type="cancel" @click="returnClick">返回</el-button>
        </div>
      </el-form>
    </div>
    <!-- 对话框 -->
    <el-dialog class="dialog-single-tips" title="操作结果：" :visible.sync="toggleDialogVisable" :show-close="false">
      <p class="dialog-single-tips-tit">定期投资终止协议成功</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="pauseSuccess">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fixedStopForm: {
        name: '',
        passwd: '',
      },
      fixedStopFormRules: {
        passwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      toggleDialogVisable: false,
      confirmInput: '',
      // 
      fundMessage: '',
      condesc: '',
      pwdError: '',
      sign: false,
    }
  },
  created () {
    this.sign = this.$route.params.title == '恒宝宝' ? true : false
    this.fundMessage = this.$route.params.fundMessage
    // console.log(this.fundMessage);
    this.condesc = "每" + this.fundMessage.investperiodsvalue + this.$parameterConfig.p_investperiods[this.fundMessage.investperiods] +
      this.$parameterConfig.p_investmode[this.fundMessage.investmode] + this.fundMessage.continueinvestamount + '(元)';
  },
  methods: {
    returnClick () {
      const path = this.$route.params.name
      this.$router.push({
        name: path,
        params: {
          active: '2'
        }
      })
    },
    stopSubmit () {
      this.pwdError = ''
      this.$refs.fixedStopFormRef.validate(valid => {
        if (!valid) return
        this.stop()
      })
    },
    stop () {
      this.$http.post(this.$apiPath.deleteSavePlannew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        direction: 'B',
        channelid: this.fundMessage.channelid,
        branchcode: this.fundMessage.branchcode,
        transactionaccountid: this.fundMessage.transactionaccountid,
        depositacct: this.fundMessage.depositacct,
        saveplanno: this.fundMessage.buyplanno,
        passwd: this.$des.enString(this.fixedStopForm.passwd, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
      }).then(res => {
        // console.log(res);
        if (res.data.code == '200') {
          this.toggleDialogVisable = true
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 11,
            fundname: this.sign ? '恒宝宝' : this.fundMessage.fundname,
            money: "",
            dtDate: "",
            fundname2: ""
          })
        } else {
          this.pwdError = res.data.message
        }
      }).catch(err => { })
    },
    pauseSuccess () {
      this.toggleDialogVisable = false
      if (this.sign) {
        this.$router.push({ name: 'fixedInvestment' })
      } else {
        this.$router.push({
          name: 'fixedManagement',
          params: {
            active: '2'
          }
        })
      }
    },
  }
}
</script>
<style lang="less" scoped>
.tips {
  color: @rColor;
  margin: 19px 0 14px 15px;
}
</style>